<div class="admin-container">
  <h2>{{pageTitle}}</h2>

  <div class="search-header">
    <!-- TABS -->
    <div class="tabs-container">
      <div class="tabs" *ngIf="userTypeId">
        <button (click)="changeAll()" class="tab" [class.active]="activeTab === 'all'">Todos
          <span class="count">({{totalTodosUsuarios}})</span>
        </button>
        <button (click)="changeNew()" class="tab" [class.active]="activeTab === 'new'">Nuevos
        </button>
      </div>
      <div class="tabs" *ngIf="!userTypeId">
        <button (click)="changeAll()" class="tab" [class.active]="activeTab === 'all'">Todos
          <span class="count">({{totalTodosUsuarios}})</span>
        </button>
        <button (click)="changeUserType(userTypesEnum.Customer.id)" class="tab"
          [class.active]="activeTab === 'new'">Usuarios
        </button>
        <button (click)="changeUserType(userTypesEnum.Coach.id)" class="tab"
          [class.active]="activeTab === 'new'">Mentores
        </button>
        <button (click)="changeUserType(userTypesEnum.Expert.id)" class="tab"
          [class.active]="activeTab === 'new'">Expertos
        </button>

      </div>
    </div>
    <!-- SEARCH BAR -->
    <div class="search-controls">
      <div class="search-container">
        <div class="search-box">
          <input type="text" [(ngModel)]="searchTerm" (input)="searchUsers()" placeholder="Buscar usuario"
            class="search-input">
          <button class="search-button">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="11" cy="11" r="8"></circle>
              <path d="m21 21-4.35-4.35"></path>
            </svg>
          </button>
        </div>
      </div>
      <!-- BOTON CREAR -->
      <button (click)="newAccount()" class="btn-create">
        Crear nueva cuenta
      </button>
    </div>

  </div>


  <div class="table-container" *ngIf="!selectedUser">
    <div class="loader" *ngIf="loading">Cargando...</div>

    <table *ngIf="!loading && users.length > 0">
      <thead>
        <tr>
          <th>Nombre y Apellido</th>
          <th>Correo</th>
          <th>Estado</th>
          <th *ngIf="!userTypeId">Tipo</th>
          <th *ngIf="userTypeId==userTypesEnum.Customer.id">Programa contratado</th>
          <th>Fecha Ingreso</th>
          <th>Mentor</th>
          <th *ngIf="userTypeId==userTypesEnum.Coach.id">Tipo Mentor</th>
          <th *ngIf="userTypeId==userTypesEnum.Expert.id">Categoría Experto</th>
          <th>Acción</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of users">
          <td>{{ user.name }}</td>
          <td>{{ user.email }}</td>
          <td>{{ user.status.name }}</td>
          <td *ngIf="!userTypeId">{{ user.type?.name }}</td>
          <td *ngIf="userTypeId==userTypesEnum.Customer.id">
            <select [(ngModel)]="user.selectedSubscriptionId" name="subscriptionType_{{user.id}}"
              (change)="updateUserSubscription(user, $event)">
              <option value="0" disabled>Sin plan</option>
              <option *ngFor="let subscription of subscriptionTypes" [value]="subscription.id">
                {{ subscription.name }}
              </option>
            </select>
            <!-- Mostrar el nombre del plan o "Sin plan" si no tiene -->
            <!-- {{ user.type?.suscriptionType?.name || "Sin plan" }} -->
          </td>
          <td>{{ user.createdAt | date : "dd/MM/yyyy" }}</td>
          <td>{{ user.coachAssigned?.name || '-' }}</td>
          <td *ngIf="userTypeId==userTypesEnum.Coach.id">
            <select [(ngModel)]="user.selectedCoachTypeId" name="coachType_{{user.id}}"
              (change)="updateCoachType(user, $event)">
              <option value="0" disabled>Sin tipo</option>
              <option *ngFor="let item of coachTypes" [value]="item.id">
                {{ item.name }}
              </option>
            </select>
          </td>
          <td *ngIf="userTypeId==userTypesEnum.Expert.id">
            <select [(ngModel)]="user.selectedExpertCategoryId" name="expertCategory_{{user.id}}"
              (change)="updateExpertCategory(user, $event)">
              <option value="0" disabled>Sin categoría</option>
              <option *ngFor="let item of expertCategories" [value]="item.id">
                {{ item.name }}
              </option>
            </select>
          </td>
          <td>
            <!-- <button (click)="editUser(user)" class="btn-edit">Editar</button> -->
            <button (click)="editarUsuario(user)" class="btn-editar">Editar</button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Controles de paginación -->
    <div class="pagination" *ngIf="!loading && totalPages > 1">
      <button [disabled]="currentPage === 1" (click)="previousPage()" class="btn-page">
        Anterior
      </button>

      <div class="page-numbers">
        <button *ngFor="let page of getPagesToShow()" [class.active]="page === currentPage" (click)="goToPage(page)"
          class="btn-page-number">
          {{ page }}
        </button>
      </div>

      <button [disabled]="currentPage === totalPages" (click)="nextPage()" class="btn-page">
        Siguiente
      </button>
    </div>
    <!-- fin Controles de paginación -->

    <!-- <div class="page-info" *ngIf="!loading && users.length > 0">
      Mostrando {{ (currentPage - 1) * pageSize + 1 }} -
      {{ Math.min(currentPage * pageSize, totalUsers) }} de
      {{ totalUsers }} usuarioss
    </div> -->

    <div class="empty-state" *ngIf="!loading && users.length === 0">
      No hay usuarios para mostrar
    </div>
  </div>

  <!-- MODAL CREAR USUARIO -->
  <div class="modal-overlay" *ngIf="showModalForm" (click)="closeModalForm()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>{{editMode ? 'Editar' : 'Agregar'}} usuario</h2>
        <button class="close-button" (click)="closeModalForm()">×</button>
      </div>

      <div class="modal-body">
        <form [formGroup]="usuarioFormGroup" (ngSubmit)="guardarUsuario()" class="example-container">
          <!-- FILA -->
          <div class="form-row">
            <div class="form-group" style="flex: 1 1 100%;">
              <label>Nombre completo*</label>
              <input type="text" class="" placeholder="Nombre completo" formControlName="FULLNAME">
              <div *ngIf="frmUsuario['FULLNAME'].invalid && (frmUsuario['FULLNAME'].dirty || frmUsuario['FULLNAME'].touched)">
                <span class="text-danger" *ngIf="frmUsuario['FULLNAME'].hasError('required')">Nombre requerido</span>
              </div>
            </div>
          </div>
          <!-- FILA -->
          <div class="form-row">
            <div class="form-group">
              <label>Correo</label>
              <input type="email" class="" placeholder="Email" formControlName="EMAIL">
              <div *ngIf="frmUsuario['EMAIL'].invalid && (frmUsuario['EMAIL'].dirty || frmUsuario['EMAIL'].touched)">
                <span class="text-danger" *ngIf="frmUsuario['EMAIL'].hasError('required')">Correo requerido</span>
                <span class="text-danger" *ngIf="frmUsuario['EMAIL'].hasError('email')">Correo no válido</span>
              </div>
            </div>

            <div class="form-group">
              <label>Celular*</label>
              <input type="number" class="" style="width: 19%;margin-right: 2px;" placeholder="Code"
                formControlName="CODETELEFONO">
              <input type="number" class="" style="width: 80%;" placeholder="Celular" formControlName="TELEFONO">
            </div>
          </div>
          <!-- FILA -->
          <div class="form-row">
            <div class="form-group">
              <label>Fecha de Ingreso</label>
              <input type="date" class="" formControlName="FECHAINGRESO">
              <div class="week-info" *ngIf="currentWeek as info">
                Semana {{ info.week }}, Día {{ info.day }}
              </div>
              <div
                *ngIf="frmUsuario['FECHAINGRESO'].invalid && (frmUsuario['FECHAINGRESO'].dirty || frmUsuario['FECHAINGRESO'].touched)">
                <span class="text-danger" *ngIf="frmUsuario['FECHAINGRESO'].hasError('required')">Fecha requerida</span>
              </div>
            </div>

            <div class="form-group">
              <label>Estado del cliente*</label>
              <select formControlName="ESTADO" (change)="selectEstado($event)">
                <option *ngFor="let item of estados" [ngValue]="item.id">
                  {{item.name}}
                </option>
              </select>
              <div *ngIf="frmUsuario['ESTADO'].invalid && (frmUsuario['ESTADO'].dirty || frmUsuario['ESTADO'].touched)">
                <span class="text-danger" *ngIf="frmUsuario['ESTADO'].hasError('required')">Estado requerido</span>
              </div>
            </div>
          </div>
          <!-- FILA -->
          <div class="form-row">
            <div class="form-group">
              <label>Programa contratado</label>
              <select formControlName="SUBSCRIPCION" (change)="selectSuscripcion($event)">
                <option *ngFor="let item of subscriptionTypes" [ngValue]="item.id">
                  {{item.name}}
                </option>
              </select>
              <div
                *ngIf="frmUsuario['FECHAINGRESO'].invalid && (frmUsuario['FECHAINGRESO'].dirty || frmUsuario['FECHAINGRESO'].touched)">
                <span class="text-danger" *ngIf="frmUsuario['FECHAINGRESO'].hasError('required')">Fecha requerida</span>
              </div>
            </div>

            <div class="form-group">
              <label>Mentor asignado</label>
              <!-- <select formControlName="MENTORASIGNADO" (change)="selectEstado($event)">
                <option *ngFor="let item of mentores" [ngValue]="item._id">
                  {{item.name}}
                </option>
              </select> -->

              <ng-select [items]="mentores" bindLabel="name" bindValue="_id" formControlName="MENTORASIGNADO">
              </ng-select>
            </div>
          </div>
          <!-- FILA -->
          <div class="form-row">
            <div class="form-group">
              <button type="butto" class="btn-cancel" (click)="closeModalForm()">Cancelar</button>
            </div>

            <div class="form-group">
              <button type="submit" class="btn-save" [disabled]="usuarioFormGroup.invalid">Guardar</button>
            </div>
          </div>

        </form>
      </div>

      <div class="modal-footer">
        <!-- <button class="cancel-button" (click)="closeModalForm()">Cerrar</button> -->
      </div>
    </div>
  </div>

</div>